import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import PageTitle from "../base/PageTitle";
import Companies from "../views/Companies";
import { useDispatch, useSelector } from "../../store";
import { useNavigate } from "react-router-dom";
import { getCompany } from "../../slices/company";

interface Props {}

const CompaniesPage: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedCompany, allowedCompanies } = useSelector(
    (store) => store.company
  );
  const { appLoaded } = useSelector((store) => store.shared);
  const { ssoStatus } = useSelector((store) => store.provider);

  useEffect(() => {
    if (!!appLoaded.companyList) {
      if (allowedCompanies.length === 1) {
        dispatch(getCompany(allowedCompanies[0].id));
        return navigate("/apps");
      }

      if (!!selectedCompany) {
        if (!selectedCompany.finishedSetup) {
          return navigate("/setup");
        } else {
          return navigate("/apps");
        }
      }
    }
  }, [
    navigate,
    dispatch,
    allowedCompanies,
    appLoaded.companyList,
    selectedCompany,
  ]);

  return (
    <Box>
      {allowedCompanies.length > 1 &&
        !selectedCompany &&
        !ssoStatus?.useSso && (
          <>
            <PageTitle title="Select Company" />
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignContent="center"
              justifyItems="center"
              alignItems="center"
              paddingX={30}
              paddingBottom={5}
            >
              <Typography variant="h4" textAlign="center">
                You have access to the following companies. Select one below to
                continue to SVPRO.
              </Typography>
            </Box>
            <Companies />
          </>
        )}
    </Box>
  );
};

export default CompaniesPage;
